
import axios from 'axios';

// 添加响应拦截器到axios实例
axios.interceptors.response.use(
  response => {
    // 检查响应数据中的code是否为B0002
    if (response.data && response.data.code === "B0002") {
      // 清除本地存储的登录信息
      localStorage.removeItem('logintoken');
      localStorage.removeItem('userdata');

      // 使用全局方法跳转到登录页面
      if (window.__router__) {
        window.__router__.push('/login');
      } else {
        window.location.hash = '#/login';
      }
      return response;
    }
    return response;
  },
  error => {
    // 检查响应状态码是否为415
    if (error.response && error.response.status === 415) {
      // 清除本地存储的登录信息
      localStorage.removeItem('logintoken');
      localStorage.removeItem('userdata');

      // 使用全局方法跳转到登录页面
      if (window.__router__) {
        window.__router__.push('/login');
      } else {
        window.location.hash = '#/login';
      }
    }
    return Promise.reject(error);
  }
);

// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: params,
    traditional: true,
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/application/json',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};
// 通用公用方法
const reqPost = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true
  }).then(res => res.data);
};
// 通用公用方法
const exportExcelPost = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true
  }).then(res => res.data);
};


export {
  loginreq,
  req,
  reqPost,
  exportExcelPost
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js